var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxoneicons4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005c74;}.cls-2{fill:#01cab8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1 copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.78,137.25l41.27-46.93a7.33,7.33,0,0,0-3.9-12l-61-13.71L134.3,10.88a7.32,7.32,0,0,0-12.6,0L89.82,64.63l-61,13.71a7.33,7.33,0,0,0-3.9,12l41.27,46.93-5.8,62.23a7.32,7.32,0,0,0,10.19,7.4L128,182.14l57.39,24.74a7.14,7.14,0,0,0,2.9.6,7.33,7.33,0,0,0,7.29-8ZM176.69,130a7.33,7.33,0,0,0-1.79,5.52l4.95,53.07-48.95-21.1a7.31,7.31,0,0,0-5.8,0l-48.95,21.1,4.95-53.07A7.33,7.33,0,0,0,79.31,130l-35.2-40,52-11.69a7.34,7.34,0,0,0,4.7-3.41L128,29l27.19,45.85a7.34,7.34,0,0,0,4.7,3.41l52,11.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.89,101a7.28,7.28,0,0,0-5.35-4.88l-25.11-5.65L134.3,68.31a7.32,7.32,0,0,0-12.6,0L108.57,90.44,83.46,96.09a7.32,7.32,0,0,0-3.89,12l17,19.33L94.18,153a7.32,7.32,0,0,0,10.19,7.4L128,150.23l23.63,10.19a7.18,7.18,0,0,0,2.9.6,7.32,7.32,0,0,0,7.29-8l-2.38-25.62,17-19.33a7.31,7.31,0,0,0,1.46-7.1Zm-31.54,19.12a7.33,7.33,0,0,0-1.79,5.52l1.53,16.47-15.19-6.55a7.31,7.31,0,0,0-5.8,0l-15.19,6.55,1.53-16.47a7.33,7.33,0,0,0-1.79-5.52L98.72,107.67,114.87,104a7.35,7.35,0,0,0,4.69-3.41L128,86.4l8.44,14.23a7.35,7.35,0,0,0,4.69,3.41l16.15,3.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128,211.57a7.32,7.32,0,0,0-7.32,7.32v22.49a7.32,7.32,0,1,0,14.64,0V218.89A7.32,7.32,0,0,0,128,211.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.86,141.69,7.92,149a7.33,7.33,0,0,0,2.41,14.25,7.47,7.47,0,0,0,2.4-.41l20.94-7.28a7.33,7.33,0,1,0-4.81-13.84Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.08,149l-20.94-7.28a7.33,7.33,0,1,0-4.81,13.84l20.94,7.28a7.52,7.52,0,0,0,2.4.41A7.33,7.33,0,0,0,248.08,149Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184,41.17a7.32,7.32,0,0,0,10.05-2.5l11.18-18.59a7.32,7.32,0,1,0-12.55-7.55L181.51,31.12A7.31,7.31,0,0,0,184,41.17Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.94,38.67a7.32,7.32,0,1,0,12.55-7.55L63.31,12.53a7.32,7.32,0,1,0-12.55,7.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxoneicons4);
export default __webpack_public_path__ + "static/media/rx one icons (4).e0b86e07bc1d734637264947e6760b04.svg";
export { ForwardRef as ReactComponent };